export default __webpack_public_path__ + "c3845da23478653f3c5fe6a61833a72d.svg";